import { useState } from 'react';
import { Link } from 'react-router-dom';
import { tvSeriesData, categories, type TVSeries } from '@/mocks/tvSeries';

export default function CategoryShowcase() {
  const [activeCategory, setActiveCategory] = useState('chinese');

  const displayCategories = categories.filter(c => c.slug !== 'all' && c.slug !== 'hot' && c.slug !== 'new');
  const filteredSeries = activeCategory === 'all'
    ? tvSeriesData.slice(0, 12)
    : tvSeriesData.filter(s => s.categorySlug === activeCategory).slice(0, 8);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            分类探索
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按类型发现你感兴趣的剧集</p>
        </div>

        <div className="flex items-center justify-center gap-1.5 mb-10 flex-wrap">
          <button
            onClick={() => setActiveCategory('all')}
            className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
              activeCategory === 'all'
                ? 'bg-primary-500 text-white'
                : 'bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200'
            }`}
          >
            全部
          </button>
          {displayCategories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => setActiveCategory(cat.slug)}
              className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                activeCategory === cat.slug
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200'
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {filteredSeries.map((series) => (
            <Link
              key={series.id}
              to={`/article/${series.id}`}
              className="group cursor-pointer bg-background-50 rounded-lg overflow-hidden"
              data-product-shop
            >
              <div className="relative aspect-[2/3] overflow-hidden">
                <img
                  src={series.posterImage}
                  alt={`${series.title} - 红桃影院高清在线观看`}
                  title={`${series.title} ${series.category} ${series.year}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded-md">
                    {series.rating}
                  </span>
                </div>
                {series.isNew && (
                  <div className="absolute top-2 right-2">
                    <span className="px-2 py-0.5 bg-accent-500 text-white text-xs font-medium rounded-md">
                      NEW
                    </span>
                  </div>
                )}
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {series.title}
                </h3>
                <div className="flex items-center gap-1.5 mt-1 flex-wrap">
                  <span className="text-xs text-foreground-500">{series.category}</span>
                  <span className="text-xs text-foreground-400">·</span>
                  <span className="text-xs text-foreground-500">{series.episodeCount}集</span>
                  <span className="text-xs text-foreground-400">·</span>
                  <span className="text-xs text-foreground-500">{series.status}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to={`/category/${activeCategory}`}
            className="inline-flex items-center gap-1.5 px-6 py-3 bg-background-50 border border-background-300 rounded-full text-sm font-medium text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-all whitespace-nowrap"
          >
            查看更多 {displayCategories.find(c => c.slug === activeCategory)?.name || '剧集'}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}